import { postInstoreCardLink } from 'core/actions/member';
import { RESET_INSTORE_CARD_LINK_DATA } from './types';

/**
 * @param {number} userOptInChoice
 * @return {Object}
 */
export const postCardLinkOffer = (offerId, paymentCard = {}) => postInstoreCardLink(offerId, paymentCard);

export const resetCardLinkData = () => ({ type: RESET_INSTORE_CARD_LINK_DATA });
